


































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";

import numeral from "numeral";

import { STORE_KEY, store } from "./_store";

import ProductCombobox from "@/components/Controls/ProductCombobox.vue";
import ProductContainerCombobox from "@/components/Controls/ProductContainerCombobox.vue";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      // 'loading', 'loaded', 'fatalError',

      "relatedProductsList",

      // 'document', 'meta'
    ]),
    ...mapGetters(STORE_KEY, ["remainsById", "totals"]),
  },
  methods: {
    ...mapActions(STORE_KEY, ["addItem", "removeItem"]),
  },
  components: {
    ProductCombobox,
    ProductContainerCombobox,
  },
})
export default class DealProducts extends Vue {
  @Prop() document!: any;
  @Prop() documentId!: string;
  @Prop() clientId!: string;
  @Prop() remains!: any[];
  @Prop() updateRemainsAction!: any;

  relatedProductsList!: any[];

  // items: any[] = [];

  formatNumber(value: any) {
    return numeral(value).format("0,0");
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    } else {
      this.$store.dispatch(`${STORE_KEY}/reset`);
    }
  }

  public mounted() {
    // console.log('this.config', this.config)
    this.$store.dispatch(`${STORE_KEY}/loadData`, {
      documentId: this.documentId,
      clientId: this.clientId,
      remains: this.remains,
    });
  }

  changeFormValue(index: number, field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      index,
      field,
      newValue: value,
    });
  }

  copyAddition() {
    let str: string = `Добавка: ${this.document.client_name}\nг ${this.document.point_city}, \n${this.document.point_address}\n`;

    str += this.relatedProductsList
      .map((item: any) => {
        console.log(item);
        return (
          item.product.label +
          " " +
          item.product_container.label +
          " * " +
          item.container_quantity +
          " = " +
          item.unit_quantity +
          " кг"
        );
      })
      .join(",\n");

    const el = document.createElement("textarea");
    el.value = str;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    const selection = document.getSelection();
    const selected =
      selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : false;
    el.select();
    // @ts-ignore
    document.execCommand("copy");
    // @ts-ignore
    document.body.removeChild(el);
    if (selected) {
      // @ts-ignore
      document.getSelection().removeAllRanges();
      // @ts-ignore
      document.getSelection().addRange(selected);
    }
    this.$buefy.snackbar.open(`Добавка скопирована`);
  }

  saving: boolean = false;

  saveFormData() {
    this.saving = true;
    // this.$v.form.$touch()

    // if(!this.$v.form.$error) {
    this.$store
      .dispatch(`${STORE_KEY}/saveForm`)
      .then((result) => {
        this.updateRemainsAction(true);
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        // this.$v.form.$reset();
        // this.$store.dispatch(`${PARENT_STORE_KEY}/updateReserves`, {
        //   zone: this.zone,
        //   reserves: this.reserves
        // });

        // this.$emit('on-need-data-reload', result.document.id)
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: "is-warning",
          message: `При сохранении возникли проблемы. Попробуйте позже.`,
        });
      })
      .finally(() => {
        this.saving = false;
      });
    // }
  }
}
